// ConfirmationModal.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({message, show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose} style={{marginTop:"200px"}}>
      <Modal.Header closeButton style={{background:"#FF3131"}}>
        <Modal.Title>Confirmation!</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
